<template>
  <StepLayout pageId="page-0" title="Choose Party Size" contentId="selectPartySize-mod">
    <div class="party-size-grid" data-toggle="buttons">
      <label 
        class="btn partySizeLabel"
        :class="{ active: String(currentSize) === String(item) }"
        v-for="item in partySizeOptions"
        :key="item"
        @click="changeSize(item, item - 1)"
      >
        <input name="partySize" type="radio" autocomplete="off" :value="item" />{{ item }}
      </label>
    </div>
  </StepLayout>
</template>
<script>
import StepLayout from "./StepLayout.vue";

export default {
  name: "ReservationStep0",
  components: {
    StepLayout
  },
  props: {
    currentSize: [String, Number],
    maxCovers: {
      type: [String, Number],
      default: 10
    }
  },
  computed: {
    partySizeOptions() {
      const parsedMaxCovers = parseInt(this.maxCovers, 10);
      const total = !isNaN(parsedMaxCovers) && parsedMaxCovers > 0 ? parsedMaxCovers : 10;
      return Array.from({ length: total }, (_, index) => index + 1);
    }
  },
  methods: {
    changeSize(item, index) { 
      this.$emit("changeSize", item, index); 
    }
  }
};
</script>

<style scoped lang="scss">
// Override global padding
#selectPartySize-mod {
}

.party-size-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
  margin-bottom: 20px;

  .partySizeLabel {
    aspect-ratio: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #F7F8F9;
    border: none;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    color: #333;
    cursor: pointer;
    transition: all 0.2s;

    input {
      display: none;
    }

    &:hover {
      background-color: #e8e8e8;
    }

    &.active {
      background-color: var(--brandColor, #4169E1);
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ReservationStep0.vue